import getBasePath from '../../functions/api-resource';

const basePath = getBasePath('apuracao_acao', 'configuracao');

const configuracaoActions = {
  buscarCamposFiltro: { methods: 'GET', url: `${basePath}/campos/filtro/{tipo}` },
};

export default (resource) => resource(`${basePath}`, {}, configuracaoActions);
